import React from 'react';
// import { useTranslation } from 'react-i18next';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Col, Row } from 'antd';
import { AgreementCheckboxLI2 } from '../Agreement/agreementCheckboxLI2';
// import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';

type AgreementCardProp = {
  setIsAgreed: (val: boolean) => void;
};

export const AgreementCard2 = ({ setIsAgreed }: AgreementCardProp) => {
  // const { t } = useTranslation();

  const onChange = (e: CheckboxChangeEvent) => {
    setIsAgreed(e.target.checked);
  };
  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24}>
        <div
          style={{ borderBottom: '1px solid #cccccc', padding: '20px 0', fontSize: '17px', fontFamily: 'Roboto400' }}
        >
          <AgreementCheckboxLI2 onChange={onChange} />
        </div>
      </Col>
    </Row>
  );
};
